import Vue from 'vue';
import * as Sentry from '@sentry/vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import registerHelpers from './util/helpers';
import registerFilters from './util/filters';
import i18n from './i18n/i18n-config';
import App from './App.vue';
import { unregisterServiceWorkers } from '@/util/unregister-service-workers';

Vue.config.productionTip = false;
registerFilters(Vue);
registerHelpers(Vue);

if (
  import.meta.env.VITE_APP_SENTRY_DSN &&
  import.meta.env.VITE_APP_SENTRY_DSN !== 'VITE_APP_SENTRY_DSN_PLACEHOLDER' // default value in env template
) {
  Sentry.init({
    environment: import.meta.env.VITE_APP_ENVIRONMENT,
    Vue,
    dsn: import.meta.env.VITE_APP_SENTRY_DSN,
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      }),
      new Sentry.Replay(),
    ],
    replaysOnErrorSampleRate: 1.0,
    ignoreErrors: [
      'Unauthenticated',
      'NavigationDuplicated',
      /Refresh token not found/,
      /Request failed with status code 409/,
      /Request failed with status code 500/,
      /Network Error/,
      /401/,
      /422/,
      /409/,
      /500/,
      /Navigation cancelled from/,
      'timeout of 0ms exceeded',
      'Network Error',
      'Request aborted',
      'Non-Error promise rejection',
      "undefined is not an object (evaluating 'a.O')",
      /Unable to preload CSS for/,
      /dynamically imported module/,
      /Importing a module script failed/,
      /Refreshing token in another tab/,
    ],
  });
}

unregisterServiceWorkers();

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
